import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "@hook/useAuth";

const Public = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated && location.pathname === "/login") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default Public;
